import { z } from "zod"
import { identityIdSchema, membershipIdSchema, tenantIdSchema, tokenIdSchema } from "./identifiers.js"

export const accessTokenClaimsV1Schema = z
  .object({
    tokenVersion: z.literal(1),
    iss: z.string().url(),
    aud: z.string().min(1).max(256),
    sub: identityIdSchema,
    membershipId: membershipIdSchema,
    tenantId: tenantIdSchema,
    jti: tokenIdSchema,
    iat: z.number().int().nonnegative(),
    exp: z.number().int().positive(),
  })
  .strict()
  .refine((claims) => claims.exp > claims.iat, {
    message: "Access token expiry must follow issuance.",
    path: ["exp"],
  })

export type AccessTokenClaimsV1 = z.infer<typeof accessTokenClaimsV1Schema>
